import { render } from "./AddNewReferralNoteOverlay.vue?vue&type=template&id=940ffbfa&scoped=true&lang=pug"
import script from "./AddNewReferralNoteOverlay.vue?vue&type=script&lang=js"
export * from "./AddNewReferralNoteOverlay.vue?vue&type=script&lang=js"

import "./AddNewReferralNoteOverlay.vue?vue&type=style&index=0&id=940ffbfa&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-940ffbfa"]])

export default __exports__